'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _alerts = require('@jg/styles/src/assets/icons/alerts.svg');

var _alerts2 = _interopRequireDefault(_alerts);

var _tickGreen = require('@jg/styles/src/assets/icons/tick-green.svg');

var _tickGreen2 = _interopRequireDefault(_tickGreen);

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = ['warning', 'error', 'success'];

var propTypes = {
  className: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(types).isRequired,
  content: _propTypes2.default.node.isRequired
};

var defaultProps = {
  className: ''
};

var Alerts = function Alerts(_ref) {
  var type = _ref.type,
      className = _ref.className,
      content = _ref.content;

  var alertsClasses = 'jg-alerts jg-alerts--' + type;
  var classes = className ? [className, alertsClasses].join(' ') : alertsClasses;

  return _react2.default.createElement(
    'div',
    { className: classes },
    _react2.default.createElement(_.Svg, { className: 'jq-alerts__icon jq-alerts__icon--' + type, markup: type === 'success' ? _tickGreen2.default : _alerts2.default }),
    content
  );
};

Alerts.propTypes = propTypes;
Alerts.defaultProps = defaultProps;

exports.default = Alerts;


// WEBPACK FOOTER //
// ../~/@jg/components/es/Alerts/Alerts.js